import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: "https://e724af6b5af4e1fe78a5a6cd461db799@o397604.ingest.us.sentry.io/4508654586429440",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'development',
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  enabled: process.env.NODE_ENV === 'production',
});

/**
 * Capture an error and send it to Sentry. Ignores 401 unauthorized errors, since they are expected
 * and we handle them in an axios interceptor.
 */
export const captureException = (error: unknown, data?: object) => {
  // TODO add dev check
  console.error(error, data);
  Sentry.captureException(error, { ...data });
};
